import { Store, StoreConfig } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { TableColumn } from '../../models/table-column';
import { OrderFilterModel } from '../../models/order/order-filter.model';
import { TextKeys } from '../../i18n/text-keys';
import {getOrderFilterOptions, getTableColumns} from './order-table-columns';

export interface OrderListState {
  columns: TableColumn[];
  filterOptions: OrderFilterModel;
  filterValue: string;
}

@Injectable({
  providedIn: 'root',
})
@StoreConfig({ name: 'order-list' })
export class OrderListStore extends Store<OrderListState> {
  constructor() {
    super({
      columns: getTableColumns(),
      filterValue: '',
      filterOptions: getOrderFilterOptions(),
    });
  }
}
